export enum BadgeTypes {
	INFO = 'INFO',
	NEGATIVE = 'NEGATIVE',
	POSITIVE = 'POSITIVE',
	WARNING = 'WARNING',
	SECONDARY = 'SECONDARY'
}
